module.exports = __webpack_public_path__ + "static/media/NCP_firstPage_ko.aa6e2dc4.png";